import React from 'react';

import Feedbackmangement from '../sections/sec-contentmangement-feedback';

const Contentmangementfeedback = () => {
    return (
        <>
                <section className='home'>
                <div className='circle-dec-sec1'></div>
                <div className='circl2-sec1-dec'></div>
        <Feedbackmangement />
        </section>
        </>
      );
}
 
export default Contentmangementfeedback;